var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-action"},[(_vm.isVisible)?_c('div',{staticClass:"action-icon",on:{"click":function () { return _vm.$emit('click'); }}},[_c('b-icon',{attrs:{"icon":_vm.open ? 'close' : 'menu'}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }